module.exports = __webpack_public_path__ + "img/veterinarian.a405a1f9.svg";